import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contact.css";
import contact from "../images/contact1.webp";

const Contact = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="contact">
      <div className="container contact__container">
        <aside
          className="contact__aside"
          data-aos={isMobile ? "fade-left" : "fade-right"}
        >
          <div className="aside__image">
            <img src={contact} alt="header" />
          </div>
          <h2>Contact Us</h2>
          <p>
            Have questions or want to learn more about our coaching services?
            Reach out to us using the form below or connect via phone, email, or
            social media. We're here to assist you with personalized guidance
            and information on our courses. Get in touch today!
          </p>
          <ul className="contact__details">
            <li>
              <i className="fas fa-phone-slash"></i>
              <h5>+91 7654227845</h5>
            </li>
            <li>
              <i className="fas fa-phone-slash"></i>
              <h5>+91 7979051640</h5>
            </li>
            <li>
              <i className="fas fa-envelope"></i>
              <h5>chetan09shree@gmail.com</h5>
            </li>
            <li>
              <i className="fas fa-map-marker-alt"></i>
              <h5>Near Bhatta Bazaar Jhanda Chowk, Purnea</h5>
            </li>
          </ul>
          <ul className="contact__socials">
            <li>
              <a href="https://www.facebook.com/p/Jee-vision-purnea-100057438309447/">
                <i className="fab fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/jeevision_official/">
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCIEy6MlPqCr2KoaJi332VZg">
                <i className="fab fa-youtube"></i>
              </a>
            </li>
            <li>
              <a href="https://linkedin.com">
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
          </ul>
        </aside>

        <form
          action="https://formspree.io/f/mblrlypp"
          method="post"
          className="contact__form"
          data-aos={isMobile ? "fade-right" : "fade-left"}
        >
          <div className="form__name">
            <input
              type="text"
              name="First Name"
              placeholder="First Name"
              required
            />
            <input
              type="text"
              name="Last Name"
              placeholder="Last Name"
              required
            />
          </div>
          <input
            type="email"
            name="Email Address"
            placeholder="Your Email Address"
            required
          />
          <textarea
            name="Message"
            rows="7"
            placeholder="Message"
            required
          ></textarea>
          <button type="submit" className="bt" id="bt">
            <span className="msg" id="msg"></span>
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
